import * as React from "react";
import api, { $ } from "kw/api";

export function useAvailableCovers({ riskProfileId }) {
  const [loading, setLoading] = React.useState(false);
  const [availableCovers, setAvailableCovers] = React.useState([]);
  React.useEffect(() => {
    async function queryAvailableCovers() {
      setLoading(true);
      try {
        const response = await api.query({
          availableCovers: [
            { riskProfileId },
            {
              id: true,
              title: true,
              description: true,
              icon: true,
              key: true,
              parentCover: {
                id: true,
                key: true,
                icon: true,
              },
              product: {
                provider: {
                  key: true,
                  name: true,
                },
              },
            },
          ],
        });
        setAvailableCovers(response?.availableCovers);
      } finally {
        setLoading(false);
      }
    }
    if (riskProfileId) {
      queryAvailableCovers();
    }
  }, [riskProfileId]);
  return { availableCovers, loading };
}

export function useUpdateCoverState({ coverId, riskProfileId }) {
  async function updateRiskCoverState(enabled) {
    const response = await api.mutation(
      {
        updateRiskCover: [
          {
            input: $("input", "UpdateRiskCoverInput!"),
          },
          {
            id: true,
            riskData: true,
          },
        ],
      },
      { input: { riskProfileId, coverId, enabled } }
    );
  }
  return {
    disableRiskCover: () => updateRiskCoverState(false),
    enableRiskCover: () => updateRiskCoverState(true),
  };
}
